import { Flex, Spacing } from '@billy/design-system'
import { ComponentType } from 'react'
import { useParams } from 'react-router'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { isSupportedCountryId } from '../../../../../vatDeclarations/utils/isSupportedCountryId'
import { useVatDeclaration } from '../../../../context/vatDeclarationContext'
import { useVatDeclarations } from '../../../../context/vatDeclarationsContext'
import { SupportedCountries } from '../../../../types/supportedCountries'
import { VatDeclarationsParams } from '../../../../types/vatDeclarationsParams'
import { VatDeclarationsCorrectionBanner } from '../../../VatDeclarationsCorrectionBanner'
import { useHasUnsettledCorrection } from '../../hooks/useHasUnsettledCorrection'
import { VatDeclarationCorrectionsTabs } from '../VatDeclarationCorrectionsTabs'
import { AuditTrail } from './elements/AuditTrail'
import { ReportContent as ReportContentDE } from './elements/DE/ReportContent'
import { ReportContent as ReportContentDK } from './elements/DK/ReportContent'
import { ReportContent as ReportContentFR } from './elements/FR/ReportContent'
import { ReportContent as ReportContentNL } from './elements/NL/ReportContent'
import * as Styled from './styles'

const COUNTRY_VIEWS: Record<SupportedCountries, ComponentType> = {
  DK: ReportContentDK,
  DE: ReportContentDE,
  FR: ReportContentFR,
  NL: ReportContentNL,
  FO: ReportContentDK,
  GL: ReportContentDK,
}

export const VatDeclarationReport = () => {
  const { organization } = useUserOrganization()
  const { vatDeclarationId } = useParams<VatDeclarationsParams>()
  const { corrections } = useVatDeclaration()
  const { isCorrectionBannerClosed } = useVatDeclarations()
  const { hasUnsettledCorrection } = useHasUnsettledCorrection(vatDeclarationId)

  const shouldShowCorrectionsTabs = corrections && corrections?.length > 1

  if (!isSupportedCountryId(organization?.countryId) || !organization) {
    return undefined
  }

  const CountryReportView = COUNTRY_VIEWS[organization.countryId]

  return (
    <Styled.VatDeclarationReportWrapper>
      <Flex gap={Spacing.S12} flexDirection="column">
        {hasUnsettledCorrection && !isCorrectionBannerClosed && <VatDeclarationsCorrectionBanner />}
        {shouldShowCorrectionsTabs && <VatDeclarationCorrectionsTabs />}
        <CountryReportView />
        <AuditTrail />
      </Flex>
    </Styled.VatDeclarationReportWrapper>
  )
}
